/* eslint-disable no-param-reassign */
import axios from './axiosInterceptor';
// eslint-disable-next-line no-unused-vars
import { roles } from './staticData';

const apiUrlPrefix = '/api/web/';

const saveTokenToLS = (t) => {
  localStorage.setItem('accessToken', t);
};
const fetchTokenFromLS = () => localStorage.getItem('accessToken');
const removeTokenFromLS = () => localStorage.removeItem('accessToken');

// vue store
export default {
  namespaced: true,
  state: {
    loggedIn: false,
    userData: {},
    JWTToken: null,
  },
  mutations: {
    updateLoggedInValue(state, newValue) {
      state.loggedIn = newValue;
    },
    updateUserData(state, newUserData) {
      state.userData = newUserData;
    },
    updateToken(state, newToken) {
      state.JWTToken = newToken;
    },
  },
  actions: {
    // check the local storage for valud token and confirm the validity
    checkToken({ commit }) {
      const savedToken = fetchTokenFromLS();
      if (savedToken) {
        const deferred = axios.get(`${apiUrlPrefix}user/authenticate`, {
          headers: {
            Authorization: `Bearer ${savedToken}`,
          },
        });
        deferred.then(
          (r) => {
            commit('updateUserData', r.data.user);
            commit('updateLoggedInValue', true);
            commit('updateToken', savedToken);
          },
          () => {
            commit('updateUserData', {});
            commit('updateLoggedInValue', false);
          },
        );
        return deferred;
      }
      return Promise.reject(new ErrorEvent('NO_TOKEN'));
    },
    // login with explicit credentials
    loginWithCredentials({ commit }, { email, password }) {
      return axios.post(`${apiUrlPrefix}user/authenticate`, { email, password })
        .then((r) => {
          commit('updateToken', r.data.token);
          saveTokenToLS(r.data.token);
        })
        .catch();
    },
    logout({ commit }) {
      removeTokenFromLS();
      commit('updateLoggedInValue', false);
      return Promise.resolve();
    },
    forgotPassword(context, { email }) {
      if (email) {
        return axios.post(`${apiUrlPrefix}user/password/forgot`, { email });
      }
      return Promise.reject();
    },
    resetPassword(context, params) {
      if (params) {
        return axios.post(`${apiUrlPrefix}user/password/reset`, params);
      }
      return Promise.reject();
    },
    checkPerms({ state }, unverifiedPerms) {
      // find any permission
      return new Promise((resolve, reject) => {
        let permFound = false;
        unverifiedPerms.forEach((up) => {
          state.userData.role.permissions.forEach((ap) => {
            if (up === ap) permFound = true;
          });
        });
        if (permFound) resolve(); else reject();
      });
    },
  },
  getters: {
    getToken(state) {
      return state.token;
    },
    verifyPerms(state) {
      return (action) => {
        const foundPerm = state.userData.role.permissions.find(e => e === action);
        if (!foundPerm) return false; return true;
      };
    },
  },
};
